export default __webpack_public_path__ + "static/media/visa.b994986b.png";